import i18next from "i18next"
import { call, fork, put, select, take, takeEvery } from "redux-saga/effects"
import * as fetchApi from "services/api/fetchApi"
import { getGlobalUi, globalUiAction } from "services/globalUi"

import { contractAction } from "../contract/action"

import { testRideAction } from "./action"

function* fetchTestRideScooter({ payload }) {
  const globalUi = yield select(getGlobalUi)
  const apiUrl = `/${globalUi.langCode}/api/customer/post-scootermodels?StoreId=${payload.storeId}`

  try {
    yield put(globalUiAction.setGlobalUI({ isLoading: true }))
    const response = yield call(fetchApi.getDataByFetch, apiUrl)
    if (response.data.Result === 1 && response.data.Data) {
      yield put({ type: testRideAction.SET_TESTRIDE_DATA, payload: { testrideScooter: response.data.Data } })
    } else {
      throw {
        // eslint-disable-line no-throw-literal
        name: response.data.MessageCode,
        message: response.data.Message,
      }
    }
  } catch (error) {
    yield put(
      globalUiAction.openErrorModal({
        title: i18next.t("sales:tr.title_testride_model_not_available"),
        content: i18next.t("sales:tr.text_please_contact_system_admin"),
      }),
    )
  } finally {
    yield put(globalUiAction.setGlobalUI({ isLoading: false }))
  }
}

function* fetchTestRidePath() {
  const globalUi = yield select(getGlobalUi)
  const apiUrl = `/${globalUi.langCode}/api/customer/get-test-ride-map`

  try {
    yield put(globalUiAction.setGlobalUI({ isLoading: true }))
    const response = yield call(fetchApi.getDataByFetch, apiUrl)
    if (response.data.Result === 1 && response.data.Data) {
      yield put({ type: testRideAction.SET_TESTRIDE_DATA, payload: { testridePathUrl: response.data.Data } })
    } else {
      throw {
        // eslint-disable-line no-throw-literal
        name: response.data.MessageCode,
        message: response.data.Message,
      }
    }
  } catch (error) {
    yield put(
      globalUiAction.openErrorModal({
        title: "Fetch testride path failed",
        content: `${error.name}, ${error.message}`,
      }),
    )
  } finally {
    yield put(globalUiAction.setGlobalUI({ isLoading: false }))
  }
}

function* fetchTestRideExhibitions() {
  const globalUi = yield select(getGlobalUi)
  const apiUrl = `/${globalUi.langCode}/api/customer/get-exhibitions`

  try {
    yield put(globalUiAction.setGlobalUI({ isLoading: true }))
    const response = yield call(fetchApi.getDataByFetch, apiUrl)

    if (response.data.Result === 1 && response.data.Data) {
      yield put({ type: testRideAction.SET_TESTRIDE_DATA, payload: { visitExhibitions: response.data.Data } })
    } else {
      throw {
        // eslint-disable-line no-throw-literal
        name: response.data.MessageCode,
        message: response.data.Message,
      }
    }
  } catch (error) {
    yield put(
      globalUiAction.openErrorModal({
        title: "Fetch testride exhibitions failed",
        content: `${error.name}, ${error.message}`,
      }),
    )
  } finally {
    yield put(globalUiAction.setGlobalUI({ isLoading: false }))
  }
}

function* setTestRideHistory({ payload }) {
  const globalUi = yield select(getGlobalUi)
  const apiUrl = `/${globalUi.langCode}/api/customer/post-test-ride-history`

  // is booking or directly testride (removed book_date & book_session)
  const postData = !payload.postData.book_id
    ? payload.postData
    : {
        name: payload.postData.name,
        phone: payload.postData.phone,
        city: payload.postData.city,
        district: payload.postData.district,
        gender: payload.postData.gender,
        email: payload.postData.email,
        scooter_model: payload.postData.scooter_model,
        plate_number: payload.postData.plate_number,
        book_id: payload.postData.book_id,
        driver_license: payload.postData.driver_license,
        activity_id: payload.postData.activity_id,
        remark: payload.postData.remark,
      }
  // in case is on booking and not the first time.
  if (payload.postData.change_sales) postData["change_sales"] = payload.postData.change_sales

  const testrideBooked = !!payload.postData.testrideBooked ? payload.postData.testrideBooked : null
  try {
    yield put(globalUiAction.setGlobalUI({ isLoading: true }))
    const response = yield call(fetchApi.postDataByFetch, apiUrl, postData)

    if (response.data.Result === 1 && response.data.Data) {
      const testrideId = response.data.Data.testride_id
      if (payload.postData.agentName) {
        yield call(fetchApi.postDataByFetch, "/tw/api/contract/set-order-contract-agent", {
          PowerOfAttorneyBase64: null,
          OrderNo: testrideId,
          ParentName: payload.postData.agentName || "",
          AgentName: null,
          AgentRelationship: null,
          OTRelationMemo: "",
        })
      }
      if (payload.postData.attachName) {
        yield call(fetchApi.postDataByFetch, "/tw/api/customer/updateattach", {
          OrderNo: testrideId,
          AttachTypeId: 501, // for test ride attachment
          AttachFiles: [
            {
              FileName: payload.postData.attachName,
              Base64: payload.postData.attachContent,
            },
          ],
        })
      }
      if (payload.postData.fileName) {
        yield call(fetchApi.postDataByFetch, "/tw/api/customer/updateattach", {
          OrderNo: testrideId,
          AttachTypeId: payload.postData.attachTypeId,
          AttachFiles: [
            {
              FileName: payload.postData.fileName,
              Base64: payload.postData.fileContent,
            },
          ],
        })
      }
      if (payload.nextState !== "testrideBooking") {
        yield put(
          contractAction.fetchALLContract(
            payload.url,
            Object.assign({ Id: testrideId }, payload.postParameter),
            payload.nextState,
          ),
        )
      } else {
        yield put(
          globalUiAction.openSuccessModal({
            title: i18next.t("sales:tr.form_msg_reserve_completed"),
            okayLabel: i18next.t("sales:tr.form_msg_btn_ok"),
            callback: () => window.location.reload(), // FIXME should handle fetching the new event in view
          }),
        )
      }

      testrideBooked !== null
        ? yield put({
            type: testRideAction.SET_TESTRIDE_DATA,
            payload: { testrideId: testrideId, testrideBooked: !testrideBooked },
          })
        : yield put({ type: testRideAction.SET_TESTRIDE_DATA, payload: { testrideId: testrideId } })
    } else {
      throw {
        // eslint-disable-line no-throw-literal
        name: response.data.MessageCode,
        message: response.data.Message,
      }
    }
  } catch (error) {
    yield put(
      globalUiAction.openErrorModal({
        title: "Set testride history failed",
        content: `${error.name}, ${error.message}`,
      }),
    )
  } finally {
    yield put(globalUiAction.setGlobalUI({ isLoading: false }))
  }
}

function* updateTestRideHistory({ payload }) {
  const globalUi = yield select(getGlobalUi)
  const apiUrl = `/${globalUi.langCode}/api/customer/put-history`
  const { postData, nextState, status, callback } = payload
  const testrideBooked = postData.testrideBooked !== undefined ? postData.testrideBooked : null

  const updatePayload =
    nextState === "qna"
      ? {
          customer_id: postData.customer_id,
          testride_id: postData.testride_id,
          test_ride_status: status,
          landing_consent: postData.contract_id,
          remark: postData.remark,
          is_accompany: 0,
        }
      : postData.testride_id
        ? {
            customer_id: postData.customer_id,
            testride_id: postData.testride_id,
            test_ride_status: status,
            landing_consent: postData.contract_id,
            remark: postData.remark,
            is_accompany: 0,
          }
        : {
            customer_id: postData.customer_id,
            landing_id: postData.landing_id,
            test_ride_status: status,
            test_ride_consent: postData.contract_id,
            remark: postData.remark,
            is_accompany: 0,
          }

  try {
    yield put(globalUiAction.setGlobalUI({ isLoading: true }))
    const response = yield call(fetchApi.putDataByFetch, apiUrl, updatePayload)
    if (response.data.Result === 1) {
      if (testrideBooked === null) {
        yield put(contractAction.setContractState({ signState: payload.nextState }))
      } else {
        yield put({ type: testRideAction.SET_TESTRIDE_DATA, payload: { testrideBooked: !testrideBooked } })
      }
      if (status === 2) {
        yield put(
          globalUiAction.openSuccessModal({
            title: i18next.t("sales:tr.title_testride_end"),
            content: i18next.t("sales:tr.hint_testride_completed"),
            callback: callback && callback(),
          }),
        )
      } else {
        if (nextState !== "qna") {
          yield put(
            globalUiAction.openSuccessModal({
              name: i18next.t("sales:tr.title_testride"),
              title: i18next.t("sales:tr.hint_establish_data_success_and_testride_ready"),
              content: i18next.t("sales:tr.text_establish_data_success_and_testride_ready"),
              okayLabel: i18next.t("sales:tr.label_testride_start"),
            }),
          )
        }
      }
    } else {
      throw {
        // eslint-disable-line no-throw-literal
        name: response.data.MessageCode,
        message: response.data.Message,
      }
    }
  } catch (error) {
    yield put(
      globalUiAction.openErrorModal({
        title: "Update testride history failed",
        content: `${error.name}, ${error.message}`,
      }),
    )
  } finally {
    yield put(globalUiAction.setGlobalUI({ isLoading: false }))
  }
}

function* setLandingHistory({ payload }) {
  const globalUi = yield select(getGlobalUi)
  const apiUrl = `/${globalUi.langCode}/api/customer/post-landing-history`
  const { book_id, testrideBooked, ...payloadReady } = payload.postData

  try {
    yield put(globalUiAction.setGlobalUI({ isLoading: true }))
    const response = yield call(fetchApi.postDataByFetch, apiUrl, payloadReady)
    if (response.data.Result === 1 && response.data.Data) {
      const testrideId = response.data.Data.testride_id

      yield put(
        contractAction.fetchALLContract(
          payload.url,
          Object.assign({ Id: testrideId }, payload.postParameter),
          payload.nextState,
        ),
      )
      yield put({ type: testRideAction.SET_TESTRIDE_DATA, payload: { testrideId: testrideId } })
      yield take(contractAction.SET_CONTRACT_STATE)
      const contractId = yield select((state) => state.contract.allContract[0].ContractId)
      yield call(updateTestRideHistory, {
        payload: {
          postData: Object.assign(
            {
              testride_id: testrideId,
              contract_id: contractId,
            },
            payloadReady,
          ),
          status: 0,
          nextState: payload.nextState,
        },
      })
    } else {
      throw {
        // eslint-disable-line no-throw-literal
        name: response.data.MessageCode,
        message: response.data.Message,
      }
    }
  } catch (error) {
    yield put(
      globalUiAction.openErrorModal({
        title: "Set landing history failed",
        content: `${error.name}, ${error.message}`,
      }),
    )
  } finally {
    yield put(globalUiAction.setGlobalUI({ isLoading: false }))
  }
}

//=====================================
//  WATCHERS
//-------------------------------------
export function* watchFetchTestRideScooter() {
  yield takeEvery(testRideAction.FETCH_TESTRIDE_SCOOTER, fetchTestRideScooter)
}

export function* watchFetchTestRidePath() {
  yield takeEvery(testRideAction.FETCH_TESTRIDE_PATH, fetchTestRidePath)
}

export function* watchFetchTestRideExhibitions() {
  yield takeEvery(testRideAction.FETCH_TESTRIDE_EXHIBITIONS, fetchTestRideExhibitions)
}

export function* watchSetTestRideHistory() {
  yield takeEvery(testRideAction.SET_TESTRIDE_HISTORY, setTestRideHistory)
}

export function* watchUpdateTestRideHistory() {
  yield takeEvery(testRideAction.UPDATE_TESTRIDE_HISTORY, updateTestRideHistory)
}

export function* watchSetLandingHistory() {
  yield takeEvery(testRideAction.SET_LANDING_HISTORY, setLandingHistory)
}

//=====================================
//  ROOT
//-------------------------------------
export const testRideSaga = [
  fork(watchFetchTestRideScooter),
  fork(watchFetchTestRidePath),
  fork(watchFetchTestRideExhibitions),
  fork(watchSetTestRideHistory),
  fork(watchUpdateTestRideHistory),
  fork(watchSetLandingHistory),
]
